import styled from "styled-components";

export const CategoryContainer = styled.div`
  width: 98%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #c6f0e8;
  border-radius: 7px;
  margin: 1%;
`;

export const IInContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 2%;
  row-gap: 4%;
  margin: 1% 1% 9% 1%;

  @media only screen and (max-width: 760px) {
    grid-template-columns: repeat(3, 1fr);
    margin: 4% 4% 12% 4%;
  }
`;

export const Title = styled.h1`
  font-size: 38px;
  margin-bottom: 25px;
  text-align: center;
  @media only screen and (max-width: 760px) {
    font-size: 27px;
    padding: 7px;
  }
`;
